/* ================================================
   RELEVIA LANDING PAGE — JavaScript
   · Scroll animations (Intersection Observer)
   · Sticky mobile CTA (appears after hero)
   · FAQ accordion (native <details>, enhanced)
   · Add-to-cart AJAX (keeps user on page)
   ================================================ */

(function () {
  'use strict';

  /* ── Scroll Animations ───────────────────────── */
  function initAnimations() {
    const elements = document.querySelectorAll('.rl-animate');
    if (!elements.length) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('rl-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -48px 0px' }
    );

    elements.forEach((el) => observer.observe(el));
  }

  /* ── Sticky Mobile CTA ───────────────────────── */
  function initStickyCTA() {
    const stickyCTA = document.querySelector('.rl-sticky-cta');
    const hero = document.querySelector('#rl-hero');
    if (!stickyCTA || !hero) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) {
          stickyCTA.classList.add('rl-sticky-cta--visible');
        } else {
          stickyCTA.classList.remove('rl-sticky-cta--visible');
        }
      },
      { threshold: 0.1 }
    );

    observer.observe(hero);
  }

  /* ── AJAX Add to Cart ────────────────────────── */
  function initAjaxCart() {
    document.addEventListener('submit', async (e) => {
      const form = e.target;

      // Only handle our landing forms
      if (!form.classList.contains('rl-product-form')) return;

      e.preventDefault();

      const btn = form.querySelector('[type="submit"]');
      if (!btn || btn.disabled) return;

      const originalText = btn.innerHTML;
      btn.disabled = true;
      btn.innerHTML = '<span>Adding…</span>';

      try {
        const formData = new FormData(form);
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          body: formData,
        });

        if (!response.ok) throw new Error('Cart error');

        btn.innerHTML = '<span>Added!</span>';

        // Open Dawn's cart drawer if available
        setTimeout(() => {
          const cartDrawerTrigger = document.querySelector('[data-cart-drawer-toggle], cart-drawer');
          if (cartDrawerTrigger) {
            document.dispatchEvent(new CustomEvent('cart:open'));
          }

          // Update cart bubble count
          fetch('/cart.js')
            .then((r) => r.json())
            .then((cart) => {
              const bubbles = document.querySelectorAll('.cart-count-bubble, [data-cart-count]');
              bubbles.forEach((b) => {
                b.textContent = cart.item_count;
              });
            });

          btn.disabled = false;
          btn.innerHTML = originalText;
        }, 1200);
      } catch {
        btn.disabled = false;
        btn.innerHTML = originalText;
        // Fallback: navigate to cart
        window.location.href = '/cart';
      }
    });

    // Also handle sticky CTA clicks
    const stickyCTABtn = document.querySelector('.rl-sticky-cta__btn');
    if (stickyCTABtn) {
      stickyCTABtn.addEventListener('click', () => {
        const heroForm = document.querySelector('.rl-product-form');
        if (heroForm) {
          heroForm.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        } else {
          const heroSection = document.querySelector('#rl-hero');
          if (heroSection) heroSection.scrollIntoView({ behavior: 'smooth' });
        }
      });
    }
  }

  /* ── Smooth Scroll for anchor CTAs ──────────── */
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#rl-"]').forEach((anchor) => {
      anchor.addEventListener('click', (e) => {
        const target = document.querySelector(anchor.getAttribute('href'));
        if (!target) return;
        e.preventDefault();
        const headerOffset = parseInt(
          getComputedStyle(document.body).getPropertyValue('--header-height') || '60',
          10
        );
        const top = target.getBoundingClientRect().top + window.scrollY - headerOffset - 16;
        window.scrollTo({ top, behavior: 'smooth' });
      });
    });
  }

  /* ── Init ────────────────────────────────────── */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  function init() {
    initAnimations();
    initStickyCTA();
    initAjaxCart();
    initSmoothScroll();
  }
})();
